module.exports = __webpack_public_path__ + "static/media/menu-white.82796862.svg";